import React from "react";
import { InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import { convertToLocalTime } from "../../global";

const StyledInputLabel = styled(InputLabel)(() => ({
  wordBreak: 'break-all',
  wordWrap: 'break-word',
  whiteSpace: 'normal',
  marginTop: '0px',
  position: "relative"
}));

const AuditInfoLabel = ({ auditObject  }) => (
  <div>
    {auditObject?.createdByEmail && auditObject?.createdDate && (
      <StyledInputLabel>
        <b>Created By: </b> {auditObject.createdByEmail}
        <b> On </b> {convertToLocalTime(auditObject.createdDate)}
      </StyledInputLabel>
    )}
    {auditObject?.lastModifiedByEmail && auditObject?.lastModifiedDate && (
      <StyledInputLabel>
        <b>Updated By: </b> {auditObject.lastModifiedByEmail}
        <b> On </b> {convertToLocalTime(auditObject.lastModifiedDate)}
      </StyledInputLabel>
    )}
  </div>
);

export default AuditInfoLabel;